<style lang="scss" scoped>
.official-price-container {
  width: 702px;
  margin: 48px auto 0;
  .title {
    font-size: 28px;
    line-height: 40px;
    color: #1d1d1d;
    margin-bottom: 22px;
    font-weight: bold;
  }
  .table-container {
    display: flex;
    position: relative;
    touch-action: unset;
    * {
      touch-action: unset;
    }
    .table-bg {
      position: absolute;
      width: 100%;
      touch-action: unset;
      .header {
        height: 100px;
        background-color: #eeeeee;
      }
      .odd {
        height: 100px;
        background-color: #ffffff;
      }
      .even {
        height: 100px;
        background-color: #f7f7f7;
      }
    }
    .left {
      touch-action: unset;
      width: 180px;
      z-index: 1;
      .country-name {
        touch-action: unset;
        padding-left: 24px;
        color: #1d1d1d;
        font-size: 22px;
        background-color: #eeeeee;
        height: 100px;
        display: flex;
        // justify-content: center;
        align-items: center;
      }
      .sale-price, .china-price {
        height: 100px;
        padding-left: 24px;
        color: #1d1d1d;
        background-color: #f7f7f7;
        font-size: 22px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        touch-action: unset;
        .note {
          color: #999999;
          font-size: 18px ;
        }
      }
      .sale-price {
        background-color: #fff;
      }
    }
    .official-right {
      flex: 1;
      z-index: 1;
      position: relative;
      touch-action: unset;
      height: 300px;
      // overflow: hidden;
      .right-content {
        position: absolute;
        display: flex;
        width: 100%;
        overflow-x: scroll;
        height: 320px;
        .country-item {
          min-width: 200px;
          .header {
            color: #1d1d1d;
            font-size: 22px;
            // background-color: #eeeeee;
            height: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            .logo {
              width: 56px;
              height: 40px;
              img {
                height: 100%;
                width: 100%;
              }
            } 
          }
          .sale-official, .china-price {
            height: 100px;
            touch-action: unset;
            // padding-left: 24px;
            color: #1d1d1d;
            // background-color: #f7f7f7;
            font-size: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            &.lowest {
              color: #6F9DD8 
            }
          }
          // .sale-lowest {
          //   background-color: #fff;

          // }
        }
      }
    }
  }
}
</style>

<template>
  <div class="official-price-container">
    <div class="title">全球官方价</div>
    <div class="table-container">
      <div class="table-bg">
        <div class="header"></div>
        <div class="odd"></div>
        <div class="even"></div>
      </div>
      <div class="left">
        <div class="country-name">国家/地区</div>
        <div class="sale-price">官网售价
          <div class="note">当地货币（未避税）</div>
        </div>
        <div class="china-price">人民币价格
          <div class="note">即时汇率为准</div>
          </div>
      </div>
      <div class="official-right">
        <div class="right-content">
          <div class="country-item" v-for="(item, index) in officialList" :key="index">
            <div class="header">
              <div v-if="countryList[item.country] && countryList[item.country].icon" class="logo">
                <img :src="countryList[item.country].icon" />
              </div>
              <template v-else>{{countryList[item.country] && countryList[item.country].name}}</template>
            </div>
            <div :class="`sale-official ${item.lowest ? 'lowest': ''}`">{{countryList[item.country] && countryList[item.country].pre}}{{item.websitePrice || '-'}}</div>
            <div class="china-price">￥ {{item.rmbPrice || '-'}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const countryList = {
  'CHN': {
    name: '中国大陆',
    pre: 'CHY￥',
    icon: 'https://oss.turingsenseai.com/1603346172522709875.png'
  },
  'HK': {
    name: '香港',
    pre: 'HK$',
    icon: 'https://oss.turingsenseai.com/1603346814134900004.png'
  },
  'IT': {
    name: '意大利',
    pre: '€',
    icon: 'https://oss.turingsenseai.com/1603346220258178792.png'
  },
  'US': {
    name: '美国',
    pre: '$',
    icon: 'https://oss.turingsenseai.com/1603346253691415908.png'
  },
  'TW': {
    name: '中国台湾',
    pre: 'NT$'
  },
  'JP': {
    name: '日本',
    pre: 'JPY￥',
    icon: 'https://oss.turingsenseai.com/1603346237493113587.png'
  },
  'KR': {
    name: '韩国',
    pre: '₩',
    icon: 'https://oss.turingsenseai.com/1603346056828172039.png'
  },
  'CA': {
    name: '加拿大',
    pre: '$',
    icon: 'https://oss.turingsenseai.com/1603346080408394180.png'
  },
  'GB': {
    name: '英国',
    pre: '￡',
    icon: 'https://oss.turingsenseai.com/1603346146636076579.png'
  },
  'AU': {
    name: '澳大利亚',
    pre: 'AUD',
    icon: 'https://oss.turingsenseai.com/1603345912376671284.png'
  },
  'DE': {
    name: '德国',
    pre: '€',
    icon: 'https://oss.turingsenseai.com/1603346195320879130.png'
  },
  'RU': {
    name: '俄罗斯',
    pre: 'руб',
    icon: 'https://oss.turingsenseai.com/1603346016894289290.png'
  },
  'FR': {
    name: '法国',
    pre: '€',
    icon: 'https://oss.turingsenseai.com/1603346038460084281.png'
  },
  'ES': {
    name: '西班牙',
    pre: '€',
    icon: 'https://oss.turingsenseai.com/1603346101073719180.png'
  },
  'SG': {
    name: '新加坡',
    pre: 'S$',
    icon: 'https://oss.turingsenseai.com/1603346125070356135.png'
  },
  'AE': {
    name: '阿联酋(',
    pre: 'AED',
    icon: 'https://oss.turingsenseai.com/1603345894967781134.png'
  },
  'AR': {
    name: '阿根廷',
    pre: ' د.إ',
    icon: 'https://oss.turingsenseai.com/1603345849190410459.png'
  },
}

export default {
  props: {
    officialList: {
      default: () => {
        return []
      } 
    }
  },
  data () {
    return {
      countryList: countryList
    }
  },
  methods: {
    
  },
  mounted () {
    const priceList = [...this.officialList];
    priceList.sort((a, b) => { return a.salePrice - b.salePrice });
    priceList[0].lowest = true;
  }
}
</script>
